module.exports = __webpack_public_path__ + "img/PTOY.c8fbe9ac.svg";